import classNames from "classnames";
import { observable, runInAction } from "mobx";
import { observer } from "mobx-react";
import { useState } from "react";
import "./index.scss";

export const AuthData: any = observable({
  user: false,
});

const AuthScreen = () => {
  const [errs, setErrs] = useState(false);
  const [state, setState] = useState({
    login: "",
    password: "",
  });

  const correctData = {
    login: "novaposhta2023",
    password: "4M9WjO=vDu9w?nJku1m8%+)6@F4+mJBE",
  };

  const submit = (e: any) => {
    e.preventDefault();
    const error = !(
      correctData.login == state.login && correctData.password == state.password
    );

    setErrs(error);

    if (!error) {
      const user = "user2023";
      localStorage.setItem("auth-user", JSON.stringify(user));
      runInAction(() => {
        AuthData.user = true;
      });
    }
  };

  return (
    <section className="auth-screen">
      <form className="auth-screen__form">
        <div className={classNames("login-content2__input", errs && "error")}>
          <input
            placeholder="Login"
            className="input"
            onChange={(e) => setState({ ...state, login: e.target.value })}
            value={state.login}
          />
        </div>
        <div className={classNames("login-content2__input", errs && "error")}>
          <input
            placeholder="Password"
            className="input"
            onChange={(e) => setState({ ...state, password: e.target.value })}
            value={state.password}
          />
        </div>
        <div className="button black" onClick={submit}>
          Submit
        </div>
      </form>
    </section>
  );
};

export default observer(AuthScreen);
